import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { awsAllAccountsGroupedByOrgsSelector } from "./awsAllAccountsGroupedByOrgsSelector";
import { providerAllAccountsCombiner } from "../../combiners/providerAllAccountsCombiner";

export const awsAllAccountsSelector = createDraftSafeSelector(
  [awsAllAccountsGroupedByOrgsSelector],
  providerAllAccountsCombiner,
);
